import Button from 'components/shared/Button';
import DropzoneDesc from 'components/shared/FileDropZone/Description';
import { EBlockType, IBlock } from 'detailsv2/__blocks';

import { useUpload } from './functions';
import s from './index.module.css';
import { IUploadProps } from './types';

function Upload<T extends IBlock<EBlockType.Image> | IBlock<EBlockType.Document>>({
  availableInBasic = false,
  type,
  onUpdate,
  data,
  readonly,
}: IUploadProps<T>) {
  const { descText, uploadModalType, getMimeType, openModal, getModalTitleText } = useUpload({
    availableInBasic,
    type,
    onUpdate,
    data,
  });

  if (readonly) return null;

  return (
    <div className={s.dropzoneWrapper}>
      <DropzoneDesc
        isNoDropzone
        allowedMimeTypes={getMimeType(uploadModalType)}
        placeholder={`Click here to search or upload ${descText}.`}
        className={s.dropzoneText}
        headComponent={
          <Button htmlType="button" type="default" size="medium" onClick={openModal}>
            {getModalTitleText(uploadModalType)}
          </Button>
        }
      />
    </div>
  );
}

export default Upload;
